<template>
  <div class="wrapper">
    <h2 class="title text-center">{{ $t("etudes.ecoles.titre") }}</h2>
    <hooper :settings="hooperSettings" class="hopper mt-2 w-100 h-100">
      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + imt + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole1")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + toronto + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole2")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + parissud + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole3")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + edhec + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole4")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + montreal + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole5")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + essec + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">{{
              $t("etudes.ecoles.ecole6")
            }}</small>
          </h4>
        </md-card>
      </slide>

      <slide class="team-player">
        <md-card class="md-card-plain">
          <div class="md-layout-item mx-auto">
            <div
              :style="{ 'background-image': 'url(' + princeton + ')' }"
              alt="Thumbnail Image"
              class="img-raised imgcar rounded img-fluid"
            />
          </div>
          <h4 class="card-title text-center">
            <small class="card-description text-muted">
              {{ $t("etudes.ecoles.ecole7") }}
            </small>
          </h4>
        </md-card>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <h2 class="title text-center">
      <md-button class="md-success md-lg text-center" @click="goto()">
        {{ $t("etudes.commencer") }}
      </md-button>
    </h2>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
export default {
  bodyClass: "etude",
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    imt: {
      type: String,
      default: require("@/assets/img/imt.jpeg")
    },
    parissud: {
      type: String,
      default: require("@/assets/img/parissud.jpeg")
    },
    edhec: {
      type: String,
      default: require("@/assets/img/edhec.jpeg")
    },
    essec: {
      type: String,
      default: require("@/assets/img/essec.png")
    },
    toronto: {
      type: String,
      default: require("@/assets/img/toronto.jpeg")
    },
    montreal: {
      type: String,
      default: require("@/assets/img/montreal.jpeg")
    },
    princeton: {
      type: String,
      default: require("@/assets/img/princeton.jpeg")
    }
  },

  data() {
    return {
      hooperSettings: {
        infiniteScroll: true,
        centerMode: false,
        autoPlay: true,
        playSpeed: 5000,
        breakpoints: {
          2400: {
            itemsToShow: 7
          },
          1800: {
            itemsToShow: 6
          },
          1500: {
            itemsToShow: 5
          },
          1100: {
            itemsToShow: 4
          },
          1024: {
            itemsToShow: 4
          },
          630: {
            itemsToShow: 2
          },
          504: {
            itemsToShow: 2
          },
          330: {
            itemsToShow: 2
          },
          0: {
            itemsToShow: 1
          }
        }
      }
    };
  },

  methods: {
    goto() {
      this.$router.push({ path: '/procedure', query: { type: 'etude' } })
    }
  }
};
</script>

<style lang="scss" scoped>
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
.img-raised {
  width: 100%;
}
.imgcar {
  width: 100%;
  height: 200px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
